import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profile-tab-testimonials',
  templateUrl: './profile-tab-testimonials.component.html',
  styleUrls: ['./profile-tab-testimonials.component.scss']
})
export class ProfileTabTestimonialsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
